import SimpleTable from "@/components/SimpleTable";
import { ROLE } from "@/config/role";
import { Assessor } from "@/schema/console/assessors/Assessor";
import AssessorTableRowActions from "@/src/console/(auth)/assessors/_components/AssessorTableRowActions";
import { useTranslation } from "react-i18next";

interface AssessorTableProps {
  isLoading: boolean;
  data: Assessor[];
}

function AssessorTable({ isLoading, data }: AssessorTableProps) {
  const { t } = useTranslation();

  return (
    <SimpleTable
      isLoading={isLoading}
      data={data}
      columns={[
        {
          key: "name",
          label: t("name"),
          render: ({ name }) => name,
        },
        {
          key: "email",
          label: t("email"),
          render: ({ email }) => email,
        },
        {
          key: "role",
          label: t("role"),
          render: ({ role }) =>
            role === ROLE.ADMIN ? t("admin") : t("assessor"),
        },
        {
          key: "company",
          label: t("companies"),
          render: ({ companies, role }) => {
            if (role === ROLE.ADMIN) {
              return t("all-companies");
            } else {
              if (companies.length === 0) return t("no-company");
              return (
                <div>
                  {companies.map(({ id, name }) => (
                    <div key={id}>{name}</div>
                  ))}
                </div>
              );
            }
          },
        },
        {
          width: "70px",
          key: "action",
          label: "",
          render: (assessor) => <AssessorTableRowActions assessor={assessor} />,
        },
      ]}
    />
  );
}

export default AssessorTable;
